/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";

export default function RoleGuard({ children }) {

    const navigate = useNavigate();
    const location = useLocation();

    const redirectToLogin = () => {
        const redirectUrl = `${location.pathname}${location.search}`;
        //only setting this for managePlan route as per requirement.
        if(redirectUrl=="/user/managePlan"){
        localStorage.setItem("redirectUrl", redirectUrl);
        }
        localStorage?.removeItem("accessToken");
        localStorage?.removeItem("idToken");
        navigate("/");
        window.location.reload();
    }

    useEffect(() => {
        Auth.currentSession()
            .then((session) => {
                const isValid = session?.isValid();
                if (!isValid) {
                    redirectToLogin();
                }
            })
            .catch(() => {
                redirectToLogin();
            });
    }, [location]);

    return <>{children}</>
}